/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PopularGenre } from './PopularGenre';
import {
    PopularGenreFromJSON,
    PopularGenreFromJSONTyped,
    PopularGenreToJSON,
} from './PopularGenre';

/**
 * 
 * @export
 * @interface PopularGenresResponse
 */
export interface PopularGenresResponse {
    /**
     * 
     * @type {Array<PopularGenre>}
     * @memberof PopularGenresResponse
     */
    data: Array<PopularGenre>;
}

/**
 * Check if a given object implements the PopularGenresResponse interface.
 */
export function instanceOfPopularGenresResponse(value: object): value is PopularGenresResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function PopularGenresResponseFromJSON(json: any): PopularGenresResponse {
    return PopularGenresResponseFromJSONTyped(json, false);
}

export function PopularGenresResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopularGenresResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PopularGenreFromJSON)),
    };
}

export function PopularGenresResponseToJSON(value?: PopularGenresResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PopularGenreToJSON)),
    };
}

